<template>
    <div id="start_message_block" class="d-flex h-full flex-column" :class="!isMobileAndTablet ? 'justify-center' : ''">

        <div class="d-flex flex-column justify-center align-center">
            <asset-image :src="require('../../images/ai_navigator/ai_navigator_icon.svg')" width="64">
            </asset-image>

            <h2 class="text-h5 text--primary text-center mt-2 mb-3">Ask code questions with AI Navigator</h2>
        </div>

        <chat-message type="system" class="mb-1">

            <p>
                Got a code question? Just ask. I'm here to help you figure it out &ndash; no jargon, no hassle. Ask
                anything, and I'll do my best to get you what you need.
            </p>

            <p class="font-weight-bold mb-2">
                <template v-if="isRecentAskedQuestionsAvailable">
                    Recently Asked
                </template>
                <template v-else>
                    Not sure where to start? Try one of these questions:
                </template>
            </p>

            <v-progress-linear v-if="loadingQuestion" :active="true" color="primary" indeterminate
                style="min-width: 10em;"></v-progress-linear>
            <p v-else v-for="(question, key) in questions" class="mb-2" :key="key">
                <a href="#" @click.prevent="questionClicked(question)">
                    {{ isRecentAskedQuestionsAvailable ? question.question : question }}
                </a>
            </p>

        </chat-message>

    </div>
</template>

<script>
import AssetImage from "../AssetImage.vue";
import ChatMessage from "./chat/ChatMessage.vue";
import { ApiService } from "../../api/ApiService";
import Mobile from "../inc/mixins/mobile";

export default {
    components: { ChatMessage, AssetImage },
    emits: ['question-clicked'],
    mixins: [
        Mobile
    ],
    props: {
        canSendMessages: {
            type: Boolean,
            required: false,
            default: true
        }
    },
    data() {
        return {
            loadingQuestion: true,
            questions: [
                'Is there a minimum temperature that a home heating system must be able to provide heat for?',
                'Are drinking fountains required in restaurants?',
                'In a school, how much artwork is permitted on the walls of corridors and classrooms?'
            ],
            isRecentAskedQuestionsAvailable: false,
        }
    },
    methods: {
        questionClicked(question) {
            if (question) {
                this.$emit('question-clicked', question);
            }
        }
    },
    mounted() {
        ApiService.getRecentAskedQuestions()
            .then((data) => {
                if (data && data.length > 0) {
                    this.isRecentAskedQuestionsAvailable = true;
                    this.questions = data;
                }
            })
            .finally(() => {
                this.loadingQuestion = false
            });
    }
}
</script>
